module.exports = "assets/img/laurence-koen-timmerman.jpg";